<template>
  <b-modal
    size="md"
    :style="{ zIndex: 200 }"
    v-model="isVisible"
    class="modal"
    :modal-class="isLoading ? 'loading' : ''"
    hide-footer
    no-close-on-backdrop
    centered
  >
    <template v-slot:modal-header="{ cancel }">
      <h5 class="modal-title">Edit Partner Telegram</h5>
      <button
        type="button"
        aria-label="Close"
        class="close"
        @click.prevent="cancel"
      >
        <span class="material-icons"> close </span>
      </button>
    </template>
    <FormGenerator
      ref="form"
      :data="form"
      :isLoading="isLoading"
      @submit="submit"
    />
    <template v-slot:modal-footer="{ cancel }">
      <b-button variant="outline" class="button" @click.prevent="cancel">
        Cancel
      </b-button>
      <b-button variant="primary" class="button" @click.prevent="submitModal">
        Save
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import FormGenerator from '@components/FormGenerator'
import TelegramPartnersMixin from '@mixins/notifications/TelegramPartnersMixin'

export default {
  components: {
    FormGenerator
  },
  mixins: [TelegramPartnersMixin],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    submit (data) {
      this.$emit('save', data)
    },
    submitModal () {
      this.$refs.form.submit()
    }
  }
}
</script>
